import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
interface Props {
  text: string | undefined;
  // RT→LL 시청 안내(라이브+ 전환 유도)면 파랑(cht_ll). 미지정 시 기존 회색(cht_al_co).
  llIntro?: boolean;
}
function IntroChat(t0) {
  const $ = _c(5);
  const {
    text,
    llIntro
  } = t0;
  if (!text || text.trim() === "") {
    return null;
  }
  const t1 = llIntro ? "text-cht_ll" : "text-cht_al_co";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("whitespace-pre-wrap", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== text) {
    t3 = <div className="mb-[3px]"><span className={t2}>{text}</span></div>;
    $[2] = t2;
    $[3] = text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export default IntroChat;